// setAppHeight.js
export const setAppHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
  // Add this to handle iOS Safari specifically
  doc.style.setProperty('--real-vh', `${window.innerHeight * 0.01}px`);
};
